module.exports = __webpack_public_path__ + "img/conversion_icon.f7ec2c20.png";